const PdfViewer = ({ url }) => {
  return (
    <div className="w-full h-screen overflow-auto">
      <iframe
          src={url}
          className="w-full h-full"
          title="PDF Viewer"
        />
    </div>
  );
};

export default PdfViewer;
